import { useState } from 'react';
import { ViewName } from './util';


export const useNavigationState = () => {
  const [currentView, setCurrentView] = useState(ViewName.AssetsView);

  return {
    currentView,
    setCurrentView,
  };
};
